module.exports = __webpack_public_path__ + "static/media/custom-product.1214b213.png";